import { render, staticRenderFns } from "./CheckOrganizerSetup.vue?vue&type=template&id=296b0ab6&scoped=true&"
import script from "./CheckOrganizerSetup.vue?vue&type=script&lang=js&"
export * from "./CheckOrganizerSetup.vue?vue&type=script&lang=js&"
import style0 from "./CheckOrganizerSetup.vue?vue&type=style&index=0&id=296b0ab6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "296b0ab6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/dostartu.pl/app.startzone.online/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('296b0ab6')) {
      api.createRecord('296b0ab6', component.options)
    } else {
      api.reload('296b0ab6', component.options)
    }
    module.hot.accept("./CheckOrganizerSetup.vue?vue&type=template&id=296b0ab6&scoped=true&", function () {
      api.rerender('296b0ab6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CheckOrganizerSetup.vue"
export default component.exports